<template>
	<v-container>
		<v-row align-center>
			<v-col cols="6" sm="4" md="4" lg="3" class="d-flex" v-for="salon in salons" :key="salon.name">
				<v-card
					class=""
					style="position: relative;"
					flat
					:href="salon.urlFrendlyLink"
					:style="{
						color: module.textColor.color,
						'background-color': module.contentBackgroundColor.color
					}"
				>
					<v-img :src="salon.imageUrl" height="150px" width="100%"></v-img>
					<div class="chain-img-container">
						<v-img :src="salon.chainImageUrl" max-heigth="70" width="70px" height="40px" aspect-ratio="340/640"></v-img>
					</div>

					<v-card-title class="mt-1">
						{{ salon.siteName }}
					</v-card-title>

					<v-card-text>
						<div class="small-text">{{ salon.getShortAddress }}</div>

						<div v-show="salon.getHasOpeningHours">
							<span :class="salon.getIsOpenNow ? 'text--primary' : ''">{{ salon.getIsOpenNow ? 'Åpen nå' : 'Stengt' }}</span> -
							<span>{{ salon.getIsOpenNow ? 'Stenger kl. ' + salon.getTodaysOpeningHours.to : 'Åpner kl. ' + salon.getTodaysOpeningHours.from }}</span>
						</div>
					</v-card-text>
				</v-card>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
export default {
	props: ['module', 'salons']
};
</script>

<style>
.chain-img-container {
	position: absolute;
	margin-top: -26px;
	margin-left: 16px;
	width: 70px;
}

.small-text {
	font-size: 0.7rem;
}

.v-card__text,
.v-card__title {
	word-break: normal; /* maybe !important  */
}

.v-card__title {
	font-size: 1.2rem;
	line-height: 1.3rem;
}
</style>
